﻿<script>
  import Document from "./icons/Document.svelte";
  import Download from "./icons/Download.svelte";
  import Pending from "./icons/Pending.svelte";
  import RequestHistory from "./icons/RequestHistory.svelte";
  import Trash from "./icons/Trash.svelte";
  import X from "./icons/X.svelte";
  import XCircle from "./icons/XCircle.svelte";
  import CheckCircle from "./icons/CheckCircle.svelte";
  import Browse from "./icons/Browse.svelte";
  import Share from "./icons/Share.svelte";
  import Csv from "./icons/Csv.svelte";
  import CheckSolid from "./icons/CheckSolid.svelte";
  import XSolid from "./icons/XSolid.svelte";

  export let icon;
  let className;
  export { className as class };
</script>

{#if icon === 'Document'}
  <Document {className} />
{:else if icon === 'Download'}
  <Download {className} />
{:else if icon === 'Pending'}
  <Pending {className} />
{:else if icon === 'RequestHistory'}
  <RequestHistory {className} />
{:else if icon === 'Trash'}
  <Trash {className} />
{:else if icon === 'X'}
  <X {className} />
{:else if icon === 'XCircle'}
  <XCircle {className} />
{:else if icon === 'CheckCircle'}
  <CheckCircle {className} />
{:else if icon === 'Browse'}
  <Browse {className} />
{:else if icon === 'Share'}
  <Share {className} />
{:else if icon === 'Csv'}
  <Csv {className} />
{:else if icon === 'CheckSolid'}
  <CheckSolid {className} />
{:else if icon === 'XSolid'}
  <XSolid {className} />
{/if}
